import { useMutation } from '@tanstack/react-query';

import { goodsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig } from '@/libraries/react-query';

const validateGoodsItemKey: goodsTypes.ValidateItemKey = (data): Promise<{ exists: boolean }> => {
  return axios.post(`/goods/keys/validate`, data);
};

type ValidateGoodsItemOptions = {
  config?: MutationConfig<typeof validateGoodsItemKey>;
};

export function useValidateGoodsItemKey({ config = {} }: ValidateGoodsItemOptions = {}) {
  return useMutation({
    ...config,
    mutationFn: validateGoodsItemKey,
  });
}
